import AdivareInput from '../components/ui/input.vue';

export default {
  components: {
    'adivare-input': AdivareInput,
  },
  props: {
    propertyName: {
      required: true,
      type: String,
    },
    labelKey: {
      required: false,
      default: null,
      type: String,
    },
    labelText: {
      required: false,
      default: null,
      type: String,
    },
    labelClass: {
      required: false,
      default: '',
      type: String,
    },
    inputClass: {
      required: false,
      default: '',
      type: String,
    },
    legendClass: {
      required: false,
      default: '',
      type: String,
    },
    optional: {
      required: false,
      default: false,
      type: Boolean,
    },
    outerClass: {
      required: false,
      default: '',
      type: String,
    },
    formType: {
      type: String,
      required: false,
    },
    autocomplete: {
      type: String,
      required: false,
    },
    minlength: {
      type: Number,
      required: false,
    },
    maxlength: {
      type: Number,
      required: false,
    },
    rows: {
      required: false,
      type: Number,
    },
  },
  computed: {
    translationKey() {
      return `messages_nl.label.${this.labelKey}`;
    },
    fieldLabel() {
      return null === this.labelKey ? (this.labelText ?? '') : this.$t(this.translationKey);
    },
  },
};
